import React, { useState, useEffect } from 'react';
import App from './App';
import { userInfo } from './components/context/userInfo';

function Main() {
  const { email, userEmail, isMigratedToAuthz3 } = userInfo();
  const [loading, setLoading] = useState(true);
  const fetchUser = async () => {
    setLoading(true);
    // await userEmail.getUserEmailInfo();
    setLoading(false);
  };
  useEffect(() => {
    fetchUser();
  }, []);
  return (
    <>
      {!loading ? 
        <App isMigratedToAuthz3={isMigratedToAuthz3} email={email} /> : null}
    </>
  )
}

export default Main;
